import { NPIDataGridColDef } from 'src/components/NPIDataGrid/NPIDataGrid';
import {
    createColumnDef,
    getDefaultFilterOperators,
} from 'src/components/NPIDataGrid/NPIDataGrid.utils';
import StatusChip, { STATUS_CHIP_TYPES } from 'src/components/UserStatusChip/UserStatusChip';
import { SepaAgreementCallToActions } from 'src/features/finance/sepaDirectDebits/components/SepaAgreementTables/SepaAgreementTable/SepaAgreementCallToActions/SepaAgreementCallToActions';
import { SEPA_MANDATE_AGREEMENT_TABLE_TYPE } from 'src/utils/tableUtils';

export function getMerchantSepaAgreementColumns({
    merchantFilterOptions,
    handleViewRecord,
    setIdToDelete,
    setIsDeleteConfirmModalOpen,
    setIsRemindConfirmModalOpen,
    setIdToRemind,
}): NPIDataGridColDef[] {
    const colDefs: NPIDataGridColDef[] = [
        createColumnDef({
            field: 'tradingName',
            headerName: 'Merchant',
            filterOperators: getDefaultFilterOperators({
                name: 'is',
                value: 'Merchant',
                label: 'is',
                accessor: 'Merchant',
                filterOptions: merchantFilterOptions,
            }),
        }),
        createColumnDef({
            field: 'addedByName',
            headerName: 'Added By',
            filterOperators: getDefaultFilterOperators({
                name: 'is',
                value: 'Added By',
                label: 'is',
                accessor: 'Added By',
                filterOptions: merchantFilterOptions,
            }),
        }),
        createColumnDef({
            field: 'sentToEmail',
            headerName: 'Sent To',
            minWidth: 250,
            filterOperators: getDefaultFilterOperators({
                name: 'is',
                value: 'Sent To',
                label: 'is',
                accessor: 'Sent To',
                filterOptions: merchantFilterOptions,
            }),
        }),
        createColumnDef({
            field: 'contactName',
            headerName: 'Contact Name',
            minWidth: 150,
            filterOperators: getDefaultFilterOperators({
                name: 'is',
                value: 'Contact Name',
                label: 'is',
                accessor: 'Contact Name',
                filterOptions: merchantFilterOptions,
            }),
        }),
        createColumnDef({
            field: 'accountNumber',
            headerName: 'Account Number',
            filterOperators: getDefaultFilterOperators({
                name: 'is',
                value: 'Account Number',
                label: 'is',
                accessor: 'Account Number',
                filterOptions: merchantFilterOptions,
            }),
        }),
        createColumnDef({
            field: 'status',
            headerName: 'Status',
            minWidth: 300,
            renderCell: (params) => {
                return (
                    <StatusChip
                        status={params?.row?.status}
                        type={STATUS_CHIP_TYPES.SEPA_DD_MANDATE}
                    />
                );
            },
            filterOperators: getDefaultFilterOperators({
                name: 'is',
                value: 'Status',
                label: 'is',
                accessor: 'Status',
                filterOptions: merchantFilterOptions,
            }),
        }),
        createColumnDef({
            field: 'actions',
            minWidth: 100,
            renderCell: (params) => {
                return (
                    <SepaAgreementCallToActions
                        dataTestIdKey="merchant"
                        setIsDeleteConfirmModalOpen={setIsDeleteConfirmModalOpen}
                        setIdToDelete={setIdToDelete}
                        handleViewRecord={handleViewRecord}
                        params={params}
                        setIdToRemind={setIdToRemind}
                        setIsRemindConfirmModalOpen={setIsRemindConfirmModalOpen}
                        agreementType={SEPA_MANDATE_AGREEMENT_TABLE_TYPE.MERCHANT}
                    />
                );
            },
        }),
    ];
    return colDefs;
}

export function getPartnerSepaAgreementColumns({
    partnerFilterOptions,
    handleViewRecord,
    setIdToDelete,
    setIsDeleteConfirmModalOpen,
    setIsRemindConfirmModalOpen,
    setIdToRemind,
}): NPIDataGridColDef[] {
    return [
        createColumnDef({
            field: 'tradingName',
            headerName: 'Partner',
            filterOperators: getDefaultFilterOperators({
                name: 'is',
                value: 'Partner',
                label: 'is',
                accessor: 'Partner',
                filterOptions: partnerFilterOptions,
            }),
        }),
        createColumnDef({
            field: 'addedByName',
            headerName: 'Added By',
            filterOperators: getDefaultFilterOperators({
                name: 'is',
                value: 'Added By',
                label: 'is',
                accessor: 'Added By',
                filterOptions: partnerFilterOptions,
            }),
        }),
        createColumnDef({
            field: 'sentToEmail',
            headerName: 'Sent To',
            minWidth: 250,
            filterOperators: getDefaultFilterOperators({
                name: 'is',
                value: 'Sent To',
                label: 'is',
                accessor: 'Sent To',
                filterOptions: partnerFilterOptions,
            }),
        }),
        createColumnDef({
            field: 'contactName',
            headerName: 'Contact Name',
            minWidth: 150,
            filterOperators: getDefaultFilterOperators({
                name: 'is',
                value: 'Contact Name',
                label: 'is',
                accessor: 'Contact Name',
                filterOptions: partnerFilterOptions,
            }),
        }),
        createColumnDef({
            field: 'accountNumber',
            headerName: 'Account Number',
            filterOperators: getDefaultFilterOperators({
                name: 'is',
                value: 'Account Number',
                label: 'is',
                accessor: 'Account Number',
                filterOptions: partnerFilterOptions,
            }),
        }),
        createColumnDef({
            field: 'status',
            headerName: 'Status',
            minWidth: 300,
            renderCell: (params) => {
                return (
                    <StatusChip
                        status={params?.row?.status}
                        type={STATUS_CHIP_TYPES.SEPA_DD_MANDATE}
                    />
                );
            },
            filterOperators: getDefaultFilterOperators({
                name: 'is',
                value: 'Status',
                label: 'is',
                accessor: 'Status',
                filterOptions: partnerFilterOptions,
            }),
        }),
        createColumnDef({
            field: 'actions',
            minWidth: 100,
            renderCell: (params) => {
                return (
                    <SepaAgreementCallToActions
                        dataTestIdKey="partner"
                        setIsDeleteConfirmModalOpen={setIsDeleteConfirmModalOpen}
                        setIdToDelete={setIdToDelete}
                        handleViewRecord={handleViewRecord}
                        params={params}
                        setIdToRemind={setIdToRemind}
                        setIsRemindConfirmModalOpen={setIsRemindConfirmModalOpen}
                        agreementType={SEPA_MANDATE_AGREEMENT_TABLE_TYPE.PARTNER}
                    />
                );
            },
        }),
    ];
}
